import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MoveBoardDropdown from "../move-board-dropdown.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ButtonBar from "@Shared/components/general/button-bar.vue";
import { mapGetters } from "vuex";
import { GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED } from "../../../store/board-getters";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileHeaderActionButton",
  components: {
    MoveBoardDropdown,
    SimpleButton,
    ButtonBar
  },
  mixins: [validationMixin],
  validations: {
    clientProfileDetails: {
      email: {
        required,
        email
      }
    }
  },
  props: {
    loadingState: {
      type: Object,
      default: () => ({
        loading: false,
        loadingSucceeded: true
      })
    },
    clientProfileDetails: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    silentLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED])), {}, {
    currentProfileMasterUnsubscribed() {
      return this.GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED(this.clientProfileId);
    },
    subscribeText() {
      return this.currentProfileMasterUnsubscribed ? this.$t("client-profile.actions.masterSubscribe") : this.$t("client-profile.actions.masterUnsubscribe");
    },
    masterUnsubscribedAuthor() {
      return this.clientProfileDetails.authorUnsubscribed;
    },
    masterUnsubscribeDoneByClient() {
      return this.masterUnsubscribedAuthor === "client";
    },
    clientProfileHasEmail() {
      return !this.$v.clientProfileDetails.$invalid;
    },
    disabledMasterSubscribe() {
      return !this.clientProfileHasEmail || this.masterUnsubscribeDoneByClient || this.silentLoading;
    },
    masterSubscribeDisabledTitle() {
      if (this.silentLoading) return "";
      return !this.clientProfileHasEmail ? this.$t("client-profile.messages.clientProfileWithoutEmail") : this.$t("client-profile.messages.masterUnsubscribedByTheClient");
    }
  }),
  methods: {
    hide() {
      this.$refs.actionsDropdown.hide(true);
    },
    handleBoardSelect(boardId) {
      this.$emit("select-board", boardId);
    }
  }
});